import { IS_BETA, VERSION } from '../define-envs';
import { KERNEL_NAME } from '../enums';
import KernelProxy from '../kernel-proxy';
import { commonTool } from '../util';
import { KernelSelector } from './';
/**
 * 用于注册播放内核的工厂方法
 */
var KernelFactory = /** @class */ (function () {
    function KernelFactory() {
    }
    /**
     * 注册播放内核
     * @param kernelName 内核名称
     * @param kernel 内核的实现（类对象），可传入undefined相当于取消注册
     */
    KernelFactory.registerKernel = function (kernelName, kernel) {
        var _a, _b, _c;
        if (this.kernelMap[kernelName]) {
            // 替换注册，执行注销 hook
            (_b = (_a = this.kernelMap[kernelName]).unregister) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else if (!this.kernelMap[kernelName] && kernel) {
            // 新注册播放内核时，执行内核注册 hook 方法
            (_c = kernel.register) === null || _c === void 0 ? void 0 : _c.call(kernel);
        }
        // 修改为可以重复注册、替换注册
        this.kernelMap[kernelName] = kernel;
    };
    /**
   * 创建播放内核
   * @ignore
   */
    KernelFactory.createKernel = function (kernelName, conf) {
        // 如果强制指定流类型的话
        if (kernelName) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            var KernelClass = KernelFactory.kernelMap[kernelName];
            // 先检查是否有播放内核
            if (!KernelClass) {
                throw new Error("Can't find [".concat(kernelName, "] kernel"));
            }
            // 再检查播放环境是否支持播放内核
            if (KernelClass.isEnvSupport) {
                var inst = new KernelClass(conf);
                if (KernelClass.exportApis) {
                    commonTool.assignApiToPrototype(inst, KernelProxy.prototype, KernelClass.exportApis);
                }
                return inst;
            }
            // 浏览器不支持
            window.console.log("Browser does not support kernelName[".concat(kernelName, "]"));
        }
        return new KernelFactory.kernelMap.origin(conf);
    };
    /**
     * @deprecated 创建thumbplayer-core实例，请使用new KernelProxy创建
     */
    KernelFactory.create = function (conf) {
        // 较早设计，因为目前有外部调用，先使用废弃方式提示
        return new KernelProxy(conf);
    };
    /**
     * 根据播放内核名称获取播放内核的类对象
     */
    KernelFactory.getKernelByName = function (kernelName) {
        return KernelFactory.kernelMap[kernelName];
    };
    /**
     * 检查某个播放内核是否支持指定的UrlConfig播放
     * @param kernelName 播放内核名称
     * @param urlConfig 指定的视频播放地址
     */
    KernelFactory.isKernelSupportByUrlConfig = function (kernelName, urlConfig) {
        return KernelSelector.getSelector().isKernelSupportByUrlConfig(kernelName, urlConfig);
    };
    /**
     * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
     * @param value 播放配置信息
     * @param forceKernelName 强制使用某种内核
     * @param kernelPriority 自定义内核选择时的优先级
     * @returns 被选择的内核名称
     */
    KernelFactory.selectKernel = function (value, forceKernelName, kernelPriority) {
        var checkValue = (value instanceof Array) ? value[0] : value;
        return KernelSelector.getSelector().selectByURLConfig(checkValue, forceKernelName, kernelPriority);
    };
    KernelFactory.kernelMap = {};
    return KernelFactory;
}());
export default KernelFactory;
/**
 * 根据内核名称获取内核的cdn文件地址
 */
export function getKernelCdnPath(kernelName, autoLoadKernelVerMap) {
    var _a;
    if (autoLoadKernelVerMap === void 0) { autoLoadKernelVerMap = {}; }
    var version = IS_BETA ? 'beta' : (autoLoadKernelVerMap[kernelName] || VERSION);
    var kernelCdnPrefix = "core/".concat(version);
    var kernelName2CdnPathMap = (_a = {},
        _a[KERNEL_NAME.HLS_JS] = "".concat(kernelCdnPrefix, "/txhlsjs-kernel.js"),
        _a[KERNEL_NAME.FLV_JS] = "".concat(kernelCdnPrefix, "/flvjs-kernel.js"),
        _a[KERNEL_NAME.DEMUX_2_FMP4] = "".concat(kernelCdnPrefix, "/demux2fmp4-kernel.js"),
        _a[KERNEL_NAME.WASM] = "".concat(kernelCdnPrefix, "/wasm-kernel.js"),
        _a[KERNEL_NAME.WEBRTC] = "".concat(kernelCdnPrefix, "/webrtc-kernel.js"),
        _a);
    return kernelName2CdnPathMap[kernelName];
}
